export { pageViewTrackingPlugin } from './page-view-tracking';
export { pageViewTrackingPlugin as plugin } from './page-view-tracking';
